import React from 'react'
import '../css/ProgressPage.css';
import Loader from 'react-spinners/BarLoader'

const ProgressPage = (props) => {
  return (
    <div id="progressPage" className='progressPage'>
      <div className='progress-container'>
        <img className='progress-img' src='progress-image.png' alt='프로그래스 이미지'></img>
        <div className='progress-text-wrapper'>
          <div className='progress-text'>Processing...</div>
          <Loader color={'#FFFFFF'} width={220} loading={true} speedMultiplier={1.2}></Loader>
        </div>
      </div>
    </div>
  );
}
 
export default ProgressPage;
 